<script setup lang="ts">
import { ref, Ref } from 'vue';

    const props = withDefaults(defineProps<{
        classes?: any[],
        styleStr?: string
    }>(), {
        styleStr:""
    })

    let classList: Ref<any> = ref(props.classes)
    const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

</script>

<template>
    <div class="d-flex align-items-center">
        <img :src="VITE_ASSET_URL + 'assets/logo/logos_Topela_Phone.svg'" width="60" alt="Logo topela" :class="classList" />
        <span class="m-0" :style="styleStr">
            <span class="topela-blue-color topela-text">tope</span>
            <span class="topela-orange-color topela-text">la</span>
        </span>
    </div>
</template>

<style scoped>
.topela-blue-color{
    color: #32A5CF;
}
.topela-orange-color{
    color: #F0A43D;
}
.topela-text {
    font-size: 70px !important;
    font-weight: 600;
    font-family: 'Raleway', sans-serif !important
}
@media (max-width: 768px) {
  .topela-text {
    font-size: 45px !important;
  }
}

@media (max-width: 480px) {
  .topela-text {
    font-size: 45px !important;
  }
}
</style>
